module.exports = __webpack_public_path__ + "static/img/5.e4479df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/5.png
// module id = 54xy
// module chunks = 0